import React from 'react';
type LibraryViewVersionLicenseRowProps = {
  isExpanded: boolean;
  infoModel: object;
};
type LibraryViewVersionLicenseRowState = {
  isExpanded: any;
};
class LibraryViewVersionLicenseRow extends React.Component<
  LibraryViewVersionLicenseRowProps,
  LibraryViewVersionLicenseRowState
> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isExpanded: this.props.isExpanded,
    };
  }
  toggleExpanded = () => {
    let isExpanded = this.state.isExpanded;
    this.setState({ isExpanded: !isExpanded }); // eslint-disable-line
  };
  render() {
    const { infoModel } = this.props;
    let fullText =
        localStorage.getItem('license-' + [infoModel.name]) ||
        'Full license text is not available.',
      hasText = !!localStorage.getItem('license-' + [infoModel.name]),
      title = infoModel.name || 'There is no license identified by us.',
      expandElement,
      isExpanded = this.state.isExpanded;
    expandElement = (
      <span className="color--primary cursor--pointer" onClick={this.toggleExpanded}>
        {isExpanded ? 'collapse' : 'expand'}
      </span>
    );
    return (
      <div key={title} className="grid pb">
        <div className="grid__item col-1-1">
          <span className="text--bold cursor--pointer" onClick={this.toggleExpanded}>
            {title}
          </span>
          <span className="pl">{expandElement}</span>
        </div>
        <p className={'grid__item col-1-1 pt- pr ' + (!isExpanded && 'is-hiding')}>{fullText}</p>
        <div className="grid__item col-1-1 pt-">{isExpanded && hasText ? expandElement : null}</div>
      </div>
    );
  }
}
export default LibraryViewVersionLicenseRow;
